import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import Seo from '../../../components/common/Seo'
import Sidebar from '../../../components/GuestBooking/common/Sidebar'
import Header from '../../../components/header/header-rslhome'
import { useDispatch, useSelector } from '../../../redux/store'
import Footer3 from '../../../components/footer/footer-3'
import GuestUser from '../../../components/GuestBooking/guest_user_page'
import SegmentTab from '../../../components/GuestBooking/SegmentTab'
import {
  bookingUpcomingList,
  cancelTrip
} from '../../../redux/slices/product'
import { getBookingOrEnquiry } from '../../../redux/slices/common'
import Modal from '@mui/material/Modal'
import {
  Box,
  Button,
  TextField,
  InputAdornment,
  IconButton
} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import CloseIcon from '@mui/icons-material/Close' // ✅ Import Clear Icon
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { fetchSeoByPage } from '../../../lib/seoHelper'

const WishlistTable = dynamic(() => import('../../../components/GuestBooking/WishlistTable'))
const BookingDetailsPage = dynamic(() => import('../../../components/GuestBooking/BookingDetailsPage'))
const CustomTab = dynamic(() => import('../../../components/GuestBooking/CustomTab'))

const tabItems = [
  {
    type: 0,
    name: 'Upcoming'
  },
  {
    type: 1,
    name: 'History'
  }
]

const mainTab = [
  {
    type: 6,
    name: 'Activity'
  },
  {
    type: 1,
    name: 'Hotel'
  },
  {
    type: 2,
    name: 'Flight'
  },
  {
    type: 4,
    name: 'Staycation'
  }
  // {
  //   type: 11,
  //   name: "Cabs",
  // },
]

const Index = ({ meta }) => {
  const dispatch = useDispatch();
  const router = useRouter();

  const { cancelTripRes, bookingListRec, listBookingSuccessRes } = useSelector(
    state => state.product
  )
  const { bookingOrEnquiryRes } = useSelector(state => state.common)
  const [bookingDetails, setBookingDetails] = useState(false)
  const [bookingData, setBookingData] = useState([])
  const [enableSearch, setEnableSearch] = useState(false)
  const [value, setValue] = useState(0)
  const [activeTab, setActiveTab] = useState(0)
  const [segmentActiveTab, setSegmentActiveTab] = useState(0)
  const [mainActiveTab, setMainActiveTab] = useState(0)
  const [isApiCall, setIsApiCall] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(null)
  const [guestLoading, setGuestLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingClear, setLoadingClear] = useState(false)
  const [loader, setLoader] = useState(false)
  const [cancelStatus, setCancelStatus] = useState('')
  const [open, setOpen] = useState(false)
  const [cancelData, setCancelData] = useState(undefined)
  const [upcoming, setUpcoming] = useState(null)
  const [datas, setDatas] = useState([])
  const [error, setError] = useState(false)
  const [dataOne, setDataOne] = useState({
    type: 6,
    userId: JSON.parse(sessionStorage.getItem('rslkey')),
    email: '',
    loginType: 2,
    isBookingFlow: 1
  })
  const [additionalData, setAdditionalData] = useState({
    userId: JSON.parse(sessionStorage.getItem('rslkey')),
    email: '',
    loginType: 2,
    type: 6,
    isBookingFlow: 1
  })
  const [subActiveTab, setSubActiveTab] = useState(0)
  const [isBookingFlow, setIsBookingFlow] = useState(1)
  const [bookingFlow, setBookingFlow] = useState(null)
  const [enquiryTab, setEnquiryTab] = useState([])
  const [mainTab, setMainTab] = useState([])
  const [currentTab, setCurrentTab] = useState('Activity')
  const [directList, setDirectList] = useState(false)
  const [isBookEnq, setIsBookEnq] = useState(false)
  const [inputValue, setInputValue] = useState(dataOne?.email || '')
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    dispatch(getBookingOrEnquiry())
    sessionStorage.setItem('active-type', dataOne?.type)
  }, [dispatch])

  useEffect(() => {
    if (bookingOrEnquiryRes) {
      setBookingFlow(bookingOrEnquiryRes) // or use any other property as needed
    }
  }, [bookingOrEnquiryRes])

  useEffect(() => {
    const dynamicMainTab = []
    const dynamicEnquiryTab = []

    dynamicMainTab.push(
      { type: 6, name: 'Activity' },
      { type: 1, name: 'Hotel' },
      { type: 2, name: 'Flight' }
      // { type: 11, name: "Cabs" }
    )
    if (bookingFlow !== null) {
      if (bookingFlow.holidayBookingFlow === 1) {
        dynamicMainTab.push({ type: 8, name: 'Holiday' })
      } else if (bookingFlow.holidayBookingFlow === 2) {
        dynamicEnquiryTab.push({ type: 8, name: 'Holiday' })
      }

      if (bookingFlow.staycationBookingFlow === 1) {
        dynamicMainTab.push({ type: 4, name: 'Staycation' })
      } else if (bookingFlow.staycationBookingFlow === 2) {
        dynamicEnquiryTab.push({ type: 4, name: 'Staycation' })
      }

      if (bookingFlow.busRentalBookingFlow === 1) {
        dynamicMainTab.push({ type: 7, name: 'Bus Rental' })
      } else if (bookingFlow.busRentalBookingFlow === 2) {
        dynamicEnquiryTab.push({ type: 7, name: 'Bus Rental' })
      }
    }

    // if (bookingFlow.carRentalBookingFlow === 1) {
    //   dynamicMainTab.push({ type: 9, name: "Car Rental" });
    // } else if (bookingFlow.carRentalBookingFlow === 2) {
    //   dynamicEnquiryTab.push({ type: 9, name: "Car Rental" });
    // }

    if (bookingFlow?.visaBookingFlow === 1) {
      dynamicMainTab.push({ type: 10, name: "Visa" });
    } else if (bookingFlow?.visaBookingFlow === 2) {
      dynamicEnquiryTab.push({ type: 10, name: "Visa" });
    }

    setMainTab(dynamicMainTab)
    setCurrentTab(dynamicMainTab[0]?.name)
    setEnquiryTab(dynamicEnquiryTab)
  }, [bookingFlow])

  const handleBookingCancel = () => {
    setLoading(true) // Set loading to true when the button is clicked

    dispatch(
      cancelTrip({
        bookingId: cancelData?.bookingId,
        type: cancelData?.type
      })
    ).then(() => {
      setLoading(false) // Set loading back to false when the API call is complete
    })
  }

  useEffect(() => {
    if (cancelTripRes !== undefined) {
      if (cancelTripRes?.status !== -1) {
        setCancelStatus(cancelTripRes)
        setOpen(false)
        setCancelData(undefined)
      }
    } else {
      setCancelStatus(undefined)
      setOpen(false)
      setCancelData(undefined)
    }
  }, [cancelTripRes])

  const handleOpen = (bookingId, type) => {
    setOpen(true)
    setCancelData({
      bookingId: bookingId,
      type: type
    })
    // setBookingLoader(false);
  }

  const handleClose = () => {
    setOpen(false)
    setCancelData(undefined)
  }

  useEffect(() => {
    if (!isApiCall) {
      setLoading(true)
      setBookingData([])
      setDatas([])

      dispatch(bookingUpcomingList(dataOne))
    }
  }, [mainActiveTab, dataOne])

  const handleTabClick = async (index, type, bookType, name) => {
    setCurrentTab(name)
    if (bookType === 1) {
      setLoading(true)
      setMainActiveTab(index)
      sessionStorage.setItem('active-type', type)
      setDataOne(prevData => ({
        ...prevData,
        type: type
      }))
    } else {
      setLoading(true)
      setMainActiveTab(index)
      sessionStorage.setItem('active-type', type)
      setDataOne(prevData => ({
        ...prevData,
        type: type,
        isBookingFlow: bookType
      }))
    }
  }

  useEffect(() => {
    if (bookingListRec) {
      var checkId = bookingListRec.filter(data => data._id == id)
      setDatas(bookingListRec)
      setBookingData(checkId)
      // setBookingData(checkId);
      setLoading(false)
      setSelectedIndex(0)
      setIsApiCall(false)
    }
  }, [bookingListRec])

  const handleChgIsBook = (index, value) => {
    setIsBookEnq(true)
    if (!isApiCall) {
      setBookingData([])
      setDatas([])
      setIsApiCall(true)
      setLoading(true)
      if (value === 1) {
        dispatch(
          bookingUpcomingList({
            type: 6,
            userId: JSON.parse(sessionStorage.getItem('rslkey')),
            email: dataOne?.email,
            loginType: 2,
            isBookingFlow: 1
          })
        )
        setDataOne(prevData => ({
          ...prevData,
          type: 6
        }))
        setIsBookingFlow(1)
        setMainActiveTab(0)
        setCurrentTab(mainTab[0]?.name)
      } else {
        dispatch(
          bookingUpcomingList({
            type: 8,
            userId: JSON.parse(sessionStorage.getItem('rslkey')),
            email: dataOne?.email,
            loginType: 2,
            isBookingFlow: 2
          })
        )
        setDataOne(prevData => ({
          ...prevData,
          type: 8,
          isBookingFlow: 2
        }))
        setIsBookingFlow(2)
        setCurrentTab(enquiryTab[0]?.name)
        setMainActiveTab(0)
      }
    }
  }

  // ✅ Update inputValue when dataOne.email changes
  useEffect(() => {
    setInputValue(dataOne?.email || '')
  }, [dataOne?.email])

  // ✅ Email Validation Function
  const validateEmail = email => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return regex.test(email)
  }

  useEffect(() => {
    if (!inputValue) {
      setBookingData([])
    }
  }, [inputValue])

  const handleSubmit = event => {
    event.preventDefault()

    if (!validateEmail(inputValue)) {
      setError(true) // ✅ Show error if email is invalid
      return
    }
    // dispatch(bookingUpcomingList(inputValue));

    setError(false)
    setLoadingClear(true)

    // ✅ Update email only if it's different
    if (dataOne.email !== inputValue) {
      setDataOne(prev => ({ ...prev, email: inputValue }))
    }

    setTimeout(() => setLoadingClear(false), 1000) // Simulate API call
  }

  const handleInputChange = event => {
    setInputValue(event.target.value)
    setError(false) // ✅ Reset error when user starts typing
  }

  // const handleClearInput = () => {
  //   setInputValue('') // ✅ Clear input when icon is clicked
  //   setError(false)
  // }

  const handleClearInput = () => {
    // Clear email input
    setInputValue('')
    setError(false)
    setEnableSearch(false)

    // Reset all primary states
    const defaultDataOne = {
      type: 6,
      userId: JSON.parse(sessionStorage.getItem('rslkey')),
      email: '',
      loginType: 2,
      isBookingFlow: 1,
    }
    setDataOne(defaultDataOne)

    // Also reset additionalData if needed
    setAdditionalData({
      ...defaultDataOne,
    })

    // Reset flags and lists
    setIsBookingFlow(1)
    setMainActiveTab(0)
    setSegmentActiveTab(0)
    setActiveTab(0)
    setSubActiveTab(0)
    setCurrentTab('Activity')
    setSelectedIndex(null)
    setDatas([])
    setBookingData([])
    setBookingDetails(false)
    setIsApiCall(false)
    setDirectList(false)

    // Reset any other UI indicators
    setLoader(false)
    setCancelStatus('')
    setOpen(false)
    setCancelData(undefined)

    // Optionally refetch default booking list
    dispatch(bookingUpcomingList(defaultDataOne))
  }


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  return (
    <>
      <Seo noIndex={true} />
      <div className='header-margin'></div>
      <Header bgColor="#f6f6f6" />

      <div className='dashboard'>
        <div className='dashboard__sidebar bg-white scroll-bar-1'
        // style={{
        //   width: '20%',
        //   height: '100vh',
        //   borderRight: '1px solid var(--color-border)'
        // }}
        >
          <Sidebar setEnableSearch={setEnableSearch} />
        </div>

        <div className='offcanvas offcanvas-start' tabIndex='-1' id='carSidebar'>
          <div className='offcanvas-header'>
            <h5 className='offcanvas-title' id='offcanvasLabel'>Settings</h5>
            <button type='button' className='btn-close' data-bs-dismiss='offcanvas' aria-label='Close' />
          </div>
          <div className='offcanvas-body'>
            <aside className='sidebar y-gap-40  xl:d-block' style={{ marginTop: "10px" }}>
              <Sidebar enableClos={true} />
            </aside>
          </div>
        </div>


        {!enableSearch ? (
          <div className='dashboard__main'>
            <div className='guest-user-page'>
              <GuestUser
                enableSearch={enableSearch}
                setEnableSearch={setEnableSearch}
                loading={guestLoading}
                setLoading={setGuestLoading}
                setDataOne={setDataOne}
                dataOne={dataOne}
              />
            </div>
          </div>
        ) : bookingDetails ? (
          <div className='dashboard__main'>
            <BookingDetailsPage
              mainActiveTab={mainActiveTab}
              subActiveTab={subActiveTab}
              setSubActiveTab={setSubActiveTab}
              setCancelStatus={setCancelStatus}
              cancelStatus={cancelStatus}
              handleBookingCancel={handleBookingCancel}
              loading={loading}
              setLoading={setLoading}
              setSelectedIndex={setSelectedIndex}
              selectedIndex={selectedIndex}
              setDataOne={setDataOne}
              dataOne={dataOne}
              setActiveTab={setActiveTab}
              activeTab={activeTab}
              mainTab={mainTab}
              setBookingData={setBookingData}
              bookingData={bookingData}
              setBookingDetails={setBookingDetails}
              bookingDetails={bookingDetails}
              setLoader={setLoader}
              loader={loader}
              handleOpen={handleOpen}
              setDatas={setDatas}
              datas={datas}
              setDirectList={setDirectList}
              tabItems={tabItems}
              setIsBookEnq={setIsBookEnq}
            />
          </div>
        ) : (
          <div className='dashboard__main'>
            <div className='dashboard__content main_booking_list'>
              <div className="d-flex flex-column flex-md-row justify-content-between gap-3">
                <div className="row y-gap-20 justify-between items-end w-100">
                  <div className="col-12">
                    <div className="d-flex flex-column flex-md-row justify-between align-items-center">
                      {/* Title */}
                      <h1 className="text-30 lh-14 fw-600 text-center text-md-start">
                        Your trips live here
                      </h1>

                      {/* Manage Account Icon (Visible Only in Mobile) */}
                      <ManageAccountsIcon
                        data-bs-toggle="offcanvas"
                        data-bs-target="#carSidebar"
                        className="d-lg-none text-secondary"
                        fontSize="large"
                      />
                    </div>

                    {/* Subtitle */}
                    <div className="text-15 text-light-1 text-center text-md-start">
                      This page shows all your bookings.
                    </div>
                  </div>
                </div>

                {/* Email Search & Button (Responsive Alignment) */}
                <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-sm-end align-items-center w-100">
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row' }, // Stack on mobile, row on larger screens
                      gap: 1,
                      width: '100%',
                      maxWidth: 600
                    }}
                  >
                    {/* Email Input */}
                    <TextField
                      fullWidth
                      label="Guest email"
                      placeholder="Enter your email address"
                      variant="outlined"
                      size="small"
                      type="email"
                      value={inputValue}
                      onChange={handleInputChange}
                      error={error}
                      helperText={error ? "Please enter a valid email address" : ""}
                      InputProps={{
                        endAdornment: inputValue && (
                          <InputAdornment position="end">
                            <IconButton size="small" onClick={handleClearInput}>
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& label": { color: "#697488" },
                        "& label.Mui-focused": { color: "#697488" },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: error ? "red" : "#dddddd" },
                          "&:hover fieldset": { borderColor: "#dddddd" },
                          "&.Mui-focused fieldset": { borderColor: error ? "red" : "#dddddd" },
                        },
                      }}
                    />

                    {/* Search Button */}
                    {loadingClear ? (
                      <Button
                        variant="contained"
                        sx={{
                          minWidth: "120px",
                          height: "40px",
                          backgroundColor: "#6dc8bf",
                          color: "white",
                          "&:hover": { backgroundColor: "#5bb8ae" },
                        }}
                        disabled
                      >
                        <CircularProgress sx={{ color: "white" }} size={20} />
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        sx={{
                          minWidth: "120px",
                          height: "40px",
                          backgroundColor: "#6dc8bf",
                          color: "white",
                          fontSize: "14px",
                          fontWeight: "bold",
                          borderRadius: "8px",
                          textTransform: "none",
                          "&:hover": { backgroundColor: "#5bb8ae" },
                        }}
                        onClick={handleSubmit}
                        disabled={!inputValue || error}
                      >
                        Search
                      </Button>
                    )}
                  </Box>
                </div>
              </div>


              <CustomTab
                value={value}
                setValue={setValue}
                handleChgIsBook={handleChgIsBook}
              />
              <div className='my-3'>
                {isBookingFlow === 1 ? (
                  <div
                    className='tabs -bookmark js-tabs booking-list-tab'
                    style={{ display: 'flex', justifyContent: 'start' }}
                  >
                    <div
                      className='tabs__controls d-flex items-center js-tabs-controls'
                      style={{
                        width: '100%',
                        display: 'inline-flex', // Shrinks to content width
                        gap: '10px', // Adds spacing between buttons
                        overflowX: 'auto', // Enables horizontal scrolling when needed
                        whiteSpace: 'nowrap', // Prevents wrapping
                        borderRadius: '50px', // Adjust as per design
                        padding: '5px', // Adds spacing around the tabs
                        background:
                          'linear-gradient(to right, #6cc4b5, #5bb3a7)' // Adjust color to match your design
                      }}
                    >
                      {mainTab?.map((tab, index) => (
                        <button
                          key={index}
                          className={`tabs__button px-30 w-100 rounded-100 fw-600  text-white js-tabs-button ${tab?.name === currentTab
                            ? 'is-tab-el-active list-active-tab'
                            : ''
                            }`}
                          onClick={() =>
                            handleTabClick(
                              index,
                              tab.type,
                              isBookingFlow,
                              tab.name
                            )
                          }
                          style={{
                            minWidth: 'fit-content', // Button width adjusts to text length
                            padding: '10px 20px', // Adds spacing inside buttons
                            borderRadius: '30px', // Keeps the rounded look
                            backgroundColor:
                              tab?.name === currentTab
                                ? '#ffffff'
                                : 'transparent', // Active button styling
                            color:
                              tab?.name === currentTab ? '#6cc4b5' : '#ffffff', // Active text color
                            fontWeight: 'bold',
                            border: 'none',
                            cursor: 'pointer'
                          }}
                        >
                          {tab?.name}
                        </button>
                      ))}
                    </div>
                  </div>
                ) : (
                  // <div className="tabs -bookmark js-tabs booking-list-tab">
                  //   <div className="tabs__controls d-flex items-center js-tabs-controls">
                  //     {enquiryTab?.map((tab, index) => (
                  //       <button
                  //         key={index}
                  //         className={`tabs__button px-30 rounded-100 fw-600 text-white js-tabs-button ${tab?.name === currentTab ? "is-tab-el-active list-active-tab" : ""
                  //           }`}
                  //         onClick={() => handleTabClick(index, tab.type, isBookingFlow, tab.name)}
                  //       >
                  //         {/* {currentIndex === index && tab.icon && (
                  //           <img src={tab.icon} alt="icon" width="30" className="mr-10" />
                  //         )} */}
                  //         {tab?.name}
                  //       </button>
                  //     ))}
                  //   </div>
                  // </div>
                  <div
                    className='tabs -bookmark js-tabs booking-list-tab'
                    style={{ display: 'flex', justifyContent: 'start' }}
                  >
                    <div
                      className='tabs__controls d-flex items-center js-tabs-controls'
                      style={{
                        width: '100%',
                        display: 'inline-flex', // Shrinks to content width
                        gap: '10px', // Adds spacing between buttons
                        overflowX: 'auto', // Enables horizontal scrolling when needed
                        whiteSpace: 'nowrap', // Prevents wrapping
                        borderRadius: '50px', // Adjust as per design
                        padding: '5px', // Adds spacing around the tabs
                        background:
                          'linear-gradient(to right, #6cc4b5, #5bb3a7)' // Adjust color to match your design
                      }}
                    >
                      {enquiryTab?.map((tab, index) => (
                        <button
                          key={index}
                          className={`tabs__button w-100 px-30 rounded-100 fw-600 text-white js-tabs-button ${tab?.name === currentTab
                            ? 'is-tab-el-active list-active-tab'
                            : ''
                            }`}
                          onClick={() =>
                            handleTabClick(
                              index,
                              tab.type,
                              isBookingFlow,
                              tab.name
                            )
                          }
                          style={{
                            minWidth: 'fit-content', // Button width adjusts to text length
                            padding: '10px 20px', // Adds spacing inside buttons
                            borderRadius: '30px', // Keeps the rounded look
                            backgroundColor:
                              tab?.name === currentTab
                                ? '#ffffff'
                                : 'transparent', // Active button styling
                            color:
                              tab?.name === currentTab ? '#6cc4b5' : '#ffffff', // Active text color
                            fontWeight: 'bold',
                            border: 'none',
                            cursor: 'pointer'
                          }}
                        >
                          {tab?.name}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <div className='upcoming-list'>
                <div
                  style={{
                    width: 'fit-content'
                  }}
                >
                  <SegmentTab
                    activeTab={segmentActiveTab}
                    setActiveTab={setSegmentActiveTab}
                    tabItems={tabItems}
                    setSubActiveTab={setSubActiveTab}
                    setLoading={setLoading}
                  />
                </div>
                <div className='dashboard__content_tablist'>
                  <div className='py-30 px-30 rounded-4'>
                    <WishlistTable
                      subActiveTab={subActiveTab}
                      setSubActiveTab={setSubActiveTab}
                      setDataOne={setDataOne}
                      dataOne={dataOne}
                      setActiveTab={setActiveTab}
                      activeTab={activeTab}
                      setBookingData={setBookingData}
                      setIsApiCall={setIsApiCall}
                      mainActiveTab={mainActiveTab}
                      setMainActiveTab={setMainActiveTab}
                      bookingData={bookingData}
                      setBookingDetails={setBookingDetails}
                      bookingDetails={bookingDetails}
                      setSelectedIndex={setSelectedIndex}
                      selectedIndex={selectedIndex}
                      loading={loading}
                      additionalData={additionalData}
                      setAdditionalData={setAdditionalData}
                      setLoading={setLoading}
                      setDatas={setDatas}
                      datas={datas}
                      setDirectList={setDirectList}
                      tabItems={tabItems}
                      inputValue={inputValue}
                    />
                    {/* End tabs */}
                  </div>
                </div>
              </div>
              <Modal
                open={open}
                onClose={handleClose}
                sx={{
                  margin: '12px'
                }}
                aria-labelledby='parent-modal-title'
                aria-describedby='parent-modal-description'
              >
                <Box className='bookingDetailmainpopup'>
                  Are you looking to initiate a cancellation? Please note that
                  there may be a cancellation fee associated with this request.
                  <Box className='d-flex direction-row justify-center'>
                    <Box
                      sx={{
                        marginRight: '12px'
                      }}
                    >
                      <Button
                        variant='contained'
                        color='error'
                        onClick={handleBookingCancel}
                        disabled={loading}
                      >
                        {loading ? <CircularProgress size={24} /> : 'Yes'}
                      </Button>
                    </Box>
                    <Box>
                      <Button
                        variant='contained'
                        color='primary'
                        onClick={handleClose}
                      >
                        NO
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Modal>
              {/* <Footer /> */}
            </div>
            {/* End .dashboard__content */}
          </div>
        )}
      </div>
    </>
  )
}

export default Index;

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}